module.exports = __webpack_public_path__ + "static/images/help.aQX20Fc.svg";